// The store for React: each hook reads a snapshot the store keeps stable
// until something changes, so a screen re-renders exactly when its data does.
import { useSyncExternalStore } from 'react';
import type { RunProgress } from '@shared/artifacts';
import type { Id, Project } from '@shared/plan';
import { store } from './store';

export function useProjects(): readonly Project[] {
  return useSyncExternalStore(store.subscribe, store.projects);
}

export function useProject(id: Id): Project | undefined {
  return useSyncExternalStore(store.subscribe, () => store.get(id));
}

/** The latest run of each project, by project id; buildingIds and failedIds in store.ts turn it into the home list's groups. */
export function useRuns(): ReadonlyMap<Id, RunProgress> {
  return useSyncExternalStore(store.subscribe, store.runs);
}

let isReady = false;
function subscribeReady(listener: () => void): () => void {
  let on = true;
  void store.ready.then(() => {
    isReady = true;
    if (on) listener();
  });
  return () => { on = false; };
}

/** False until the local copy is loaded; the home screen shows nothing rather than an empty board until then. */
export function useStoreReady(): boolean {
  return useSyncExternalStore(subscribeReady, () => isReady);
}
